module.exports = __webpack_public_path__ + "assets/images/magenta_sport_5.e00185ee2a800ed6a36c99026bc3db47.png";